"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteCooperative = props => /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  viewBox: "0 0 222 150",
  ...props,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fillRule: "nonzero",
    fill: "none",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M128.987 24.731c-14.232-.497-27.788-5.136-40.731-10.21C75.313 9.445 62.49 3.82 48.599 1.131 39.664-.597 29.446-.84 22.248 3.994c-6.93 4.646-9.167 12.689-10.37 20.135-.906 5.615-1.438 11.51 1.041 16.761 1.723 3.646 4.782 6.709 6.898 10.2 7.358 12.149 2.161 27.13-5.819 38.993-3.733 5.564-8.08 10.873-10.967 16.795-2.886 5.923-4.222 12.71-1.697 18.753 2.505 5.99 8.47 10.488 14.931 13.652 13.126 6.428 14.42 10.76 29.58 10.715 34.035-.1 80.98-.1 114.503 0 12.4.037 24.854-1.844 37.043-3.778 6.766-1.075 13.752-2.778 18.664-6.895 6.238-5.227 7.784-14.07 3.603-20.619-7.004-10.984-26.39-13.71-31.29-25.504-2.697-6.49.074-13.72 3.993-19.749 8.409-12.911 22.503-24.24 23.246-39 .51-10.138-6.265-20.29-16.741-25.087-10.982-5.033-26.208-4.394-34.31 3.927-8.343 8.583-23.003 11.88-35.569 11.438z",
      fillOpacity: ".136",
      fill: "#1657E2",
      className: "fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M193.767 97c11.633 23.556 15.94 41.222 12.923 53h-25.846c-2.835-11.778 1.473-29.444 12.923-53z",
      fill: "#0842C0",
      className: "fill-dark-primary",
      opacity: ".503"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M33 19.355h61.25V150H33z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D0D8",
      d: "M94.25 19.355H138V150H94.25z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#091E43",
      d: "M33 15h105v4.355H33z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D0D8",
      d: "M41.75 132.581h8.75v8.71h-8.75zM41.75 80.323h8.75v8.71h-8.75zM41.75 115.161h8.75v8.71h-8.75zM41.75 62.903h8.75v8.71h-8.75zM59.25 115.161H68v8.71h-8.75zM59.25 62.903H68v8.71h-8.75zM41.75 97.742h8.75v8.71h-8.75zM41.75 45.484h8.75v8.71h-8.75zM59.25 97.742H68v8.71h-8.75zM59.25 80.323H68v8.71h-8.75zM59.25 28.065H68v8.71h-8.75zM76.75 28.065h8.75v8.71h-8.75zM41.75 28.065h8.75v8.71h-8.75zM59.25 45.484H68v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#091E43",
      d: "M59.25 132.581H68V150h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D0D8",
      d: "M76.75 132.581h8.75v8.71h-8.75zM76.75 80.323h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#091E43",
      d: "M103 62.903h8.75v8.71H103zM120.5 62.903h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D0D8",
      d: "M76.75 115.161h8.75v8.71h-8.75zM76.75 62.903h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#091E43",
      d: "M103 45.484h8.75v8.71H103zM120.5 45.484h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C3D0D8",
      d: "M76.75 97.742h8.75v8.71h-8.75zM76.75 45.484h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#091E43",
      d: "M103 28.065h8.75v8.71H103zM120.5 28.065h8.75v8.71h-8.75z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M102 89.333h60.9V150H102z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M162.9 89.333H189V150h-26.1z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M102 85h87v4.333h-87z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M110.7 132.667h8.7v8.667h-8.7zM110.7 115.333h8.7V124h-8.7zM128.1 115.333h8.7V124h-8.7zM110.7 98h8.7v8.667h-8.7zM128.1 98h8.7v8.667h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M128.1 132.667h8.7V150h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M145.5 132.667h8.7v8.667h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M171.6 132.667h8.7v8.667h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M145.5 115.333h8.7V124h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M171.6 115.333h8.7V124h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M145.5 98h8.7v8.667h-8.7z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M171.6 98h8.7v8.667h-8.7z"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "#1657E2",
      className: "fill-primary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0 150c0-5.155 4.278-9.333 9.556-9.333 2.544 0 4.856.97 6.568 2.554 2.443-4.306 7.144-7.221 12.543-7.221 7.794 0 14.135 6.077 14.328 13.644L43 150H0z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(176 20)",
      fill: "#10105A",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "13.5",
        cy: "13.5",
        r: "13.5"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "#FFF",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M191 34c0-3.314-2.885-6-6.444-6-1.716 0-3.275.624-4.43 1.642-1.648-2.768-4.818-4.642-8.46-4.642-5.256 0-9.533 3.906-9.663 8.771L162 34h29z"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      fill: "#0842C0",
      className: "fill-dark-primary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M207.767 97c11.633 23.556 15.94 41.222 12.923 53h-25.846c-2.835-11.778 1.473-29.444 12.923-53z"
      })
    })]
  })
});
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteCooperative')(IllustrationMySiteCooperative);